export default __webpack_public_path__ + "static/media/chilli.718cf99b.svg";